// extracted by mini-css-extract-plugin
module.exports = {"player":"trailer_player__eej9B"};